var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 150.05 112.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#linear-gradient-4);}.cls-6{fill:url(#linear-gradient-5);}.cls-7{fill:url(#linear-gradient-6);}.cls-8{fill:url(#linear-gradient-7);}.cls-9{fill:url(#linear-gradient-8);}.cls-10{fill:url(#linear-gradient-9);}.cls-11{fill:url(#linear-gradient-10);}.cls-12{fill:url(#linear-gradient-11);}.cls-13{fill:url(#linear-gradient-12);}.cls-14{fill:url(#linear-gradient-13);}.cls-15{fill:url(#linear-gradient-14);}.cls-16{fill:url(#linear-gradient-15);}.cls-17{fill:url(#linear-gradient-16);}.cls-18{fill:url(#linear-gradient-17);}.cls-19{fill:url(#linear-gradient-18);}.cls-20{fill:url(#linear-gradient-19);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 3.2,
    y1: 35.51,
    x2: 77.07,
    y2: 122.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#315050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42ACA5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -9.97,
    y1: 46.66,
    x2: 63.9,
    y2: 133.96,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 3.16,
    y1: 35.55,
    x2: 77.03,
    y2: 122.85,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -6.01,
    y1: 43.31,
    x2: 67.86,
    y2: 130.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 17.98,
    y1: 23.01,
    x2: 91.85,
    y2: 110.31,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -2.87,
    y1: 40.66,
    x2: 70.99,
    y2: 127.96,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 37.98,
    y1: 6.09,
    x2: 111.85,
    y2: 93.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 37.22,
    y1: 6.73,
    x2: 111.08,
    y2: 94.03,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 20.34,
    y1: 21.01,
    x2: 94.21,
    y2: 108.31,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 48,
    y1: -2.39,
    x2: 121.87,
    y2: 84.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 34.67,
    y1: 8.89,
    x2: 108.54,
    y2: 96.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 31.24,
    y1: 11.79,
    x2: 105.11,
    y2: 99.09,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 21.1,
    y1: 20.37,
    x2: 94.97,
    y2: 107.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 25.85,
    y1: 16.35,
    x2: 99.72,
    y2: 103.65,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 22.41,
    y1: 19.26,
    x2: 96.28,
    y2: 106.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 12.28,
    y1: 27.84,
    x2: 86.15,
    y2: 115.14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 17.02,
    y1: 23.82,
    x2: 90.89,
    y2: 111.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 13.59,
    y1: 26.73,
    x2: 87.46,
    y2: 114.03,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 3.45,
    y1: 35.3,
    x2: 77.32,
    y2: 122.6,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_seo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 150.05,
    height: 112.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.12,96.43H4.89a5.22,5.22,0,0,1-4.88-5V81.86H94.37v9.68C94.37,93.94,92.78,96.43,90.12,96.43ZM3.84,85.7v5.71a1.57,1.57,0,0,0,1,1.18H90.12c.12,0,.41-.46.41-1V85.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.7,108.11l-1.53-3.53c1-.41,1.74-.77,2.16-1l.13-.08a2.16,2.16,0,0,0,.31-.17,7.4,7.4,0,0,0,.24-1,30,30,0,0,0,.16-4.75c0-1.23,0-2.38,0-3.22l3.82.31c-.05.66,0,1.72,0,2.86a30.59,30.59,0,0,1-.24,5.54c-.45,2.29-1,2.95-2.46,3.74l-.12.07C35.47,107.33,34.32,107.84,33.7,108.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M60.58,108.12c-.78-.34-1.84-.82-2.5-1.18l-.09,0c-1.57-.87-2-1.54-2.44-3.77a30,30,0,0,1-.24-5.48c0-1.11,0-2.16,0-2.81l3.82-.31c.07.83.06,2,0,3.17a29.35,29.35,0,0,0,.16,4.69,10,10,0,0,0,.24,1l.3.17c.49.26,1.27.63,2.26,1.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 30.45,
    y: 104.27,
    width: 33.49,
    height: 3.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M94.34,85.75H0V30.89a4.4,4.4,0,0,1,4.4-4.4h8.89v3.84H4.4a.56.56,0,0,0-.56.56v51H90.51v-51a.57.57,0,0,0-.56-.56H81.08V26.49H90a4.4,4.4,0,0,1,4.39,4.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "21.13 78.5 7.08 78.5 7.08 33.68 13.29 33.68 13.29 37.52 10.91 37.52 10.91 74.67 21.13 74.67 21.13 78.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "87.17 78.5 73.41 78.5 73.41 74.67 83.33 74.67 83.33 37.52 81.08 37.52 81.08 33.68 87.17 33.68 87.17 78.5"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 73.34,
    y: 26.81,
    width: 3.84,
    height: 49.77
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "21.14 76.58 17.31 76.58 17.31 8.31 59.65 8.31 59.65 12.15 21.14 12.15 21.14 76.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M66.12,17.69l1.68,1.69H66.12V17.69M62.28,8.43V23.22H77.07L62.28,8.43Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 37.74,
    y: 26.5,
    width: 26.91,
    height: 3.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 37.74,
    y: 33.46,
    width: 26.91,
    height: 3.84
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "29.86 35.98 25.67 33.28 27.75 30.05 29.03 30.88 32.11 27.02 35.11 29.41 29.86 35.98"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 37.74,
    y: 44.39,
    width: 26.91,
    height: 3.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 37.74,
    y: 51.36,
    width: 26.91,
    height: 3.84
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "29.86 53.88 25.66 51.17 27.75 47.95 29.03 48.77 32.11 44.91 35.11 47.3 29.86 53.88"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 37.74,
    y: 62.29,
    width: 26.91,
    height: 3.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 37.74,
    y: 69.25,
    width: 26.91,
    height: 3.84
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "29.86 71.78 25.66 69.07 27.75 65.84 29.03 66.67 32.11 62.81 35.11 65.2 29.86 71.78"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSeo);
export default __webpack_public_path__ + "static/media/icon_seo.c05d49abd7082114a783c23ba9363c08.svg";
export { ForwardRef as ReactComponent };